
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/people/[...slug]",
      function () {
        return require("private-next-pages/people/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/people/[...slug]"])
      });
    }
  